import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "reakit";

import { NavItem } from "../Topbar/components/NavItem";

type Props = {
  variant?: "text" | "mobile";
};

export const TimeReports: FC<Props> = ({ variant = "text" }) => {
  const { t } = useTranslation("session");

  if (!window.__TIME_REPORT_URL__ || window.__TIME_REPORT_URL__ === "<TIME_REPORTING_URL>") {
    return null; // don't show the button if the URL is not set.
  }

  return (
    <MenuItem
      as={NavItem}
      onClick={() => window.open(window.__TIME_REPORT_URL__, "_blank")}
      variant={variant}
      text={t("COMPONENTS.TOPBAR.BUTTON_TIME_REPORTS")}
    />
  );
};
